import React, { Component } from 'react';

// Components and others
import PropTypes from 'prop-types';
import EditCustomerDialog from 'components/widgets/customer/EditCustomerDialog';
import Employment from 'components/modules/customer/read/personalTab/Employment';

// Material UI
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AddressSection from 'components/widgets/customer/AddressSection';
import PersonalTabContainer from 'components/containers/customer/read/PersonsalTabContainer';
import CustomerTable from 'components/modules/customer/read/personalTab/CustomerTable';
import BasicCustomerInformation from 'components/modules/customer/read/BasicCustomerInformation';
import { MEDIA_QUERY } from 'utils/enum/Core';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        background: theme.palette.background.white,
        overflow: 'auto',
        '& .gridItem': {
            display: 'flex',
            height: '100%',
            paddingRight: theme.spacing(1),
            margin: theme.spacing(2),
        },
        '& .gridTableItem': {
            display: 'flex',
            height: '100%',
            paddingRight: theme.spacing(1),
            margin: theme.spacing(1),
        },
        [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
            '& .MuiGrid-grid-xs-4, & .MuiGrid-grid-xs-8': {
                width: '100%',
                maxWidth: '100%',
                flexGrow: 'inherit',
            },
        },
    },
});

class PersonalTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openEditCustomer: false,
        };

        this.toggleOpenEditCustomer = this.toggleOpenEditCustomer.bind(this);
    }

    componentDidMount() {
        const { props: { getServicesData } } = this;

        getServicesData();
    }

    componentWillUnmount() {
        const { props: { unsubscribeEditCustomer } } = this;

        unsubscribeEditCustomer();
    }

    toggleOpenEditCustomer() {
        this.setState((prevState) => ({
            openEditCustomer: !prevState.openEditCustomer,
        }));
    }

    render() {
        const {
            props: {
                classes, data, loading, getOpportunitiesTableColumns,
                opportunities, loadingOpportunities, loadingDeals, deals,
                getDealsTableColumns, loadingInvoices, getROsTableColumns, invoices,
            },
        } = this;
        const { currentAddress, currentEmployment, customerId } = data;
        const {
            state: {
                openEditCustomer,
            },
        } = this;

        return (
            <Grid container spacing={0} className={classes.root}>
                <Grid item xs={4}>
                    <Grid container>
                        <Grid item xs={12} className="gridItem">
                            <BasicCustomerInformation
                                loading={loading}
                                record={data}
                                title="Personal"
                                showEditCustomer
                                displayLink={false}
                            />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} className="gridItem">
                            <AddressSection addressInformation={currentAddress} customerId={customerId} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} className="gridItem">
                            <Employment record={currentEmployment} customerId={customerId} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={8}>
                    <Grid container>
                        <Grid item xs={12} className="gridTableItem">
                            <CustomerTable
                                title="Opportunities"
                                items={opportunities}
                                loadTable={!loadingOpportunities}
                                getColumns={getOpportunitiesTableColumns}
                            />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} className="gridTableItem">
                            <CustomerTable
                                title="Deals"
                                items={deals}
                                loadTable={!loadingDeals}
                                getColumns={getDealsTableColumns}
                            />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} className="gridTableItem">
                            <CustomerTable
                                title="Invoices"
                                items={invoices}
                                loadTable={!loadingInvoices}
                                getColumns={getROsTableColumns}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {openEditCustomer && (
                    <EditCustomerDialog
                        open={openEditCustomer}
                        record={data}
                        toggleModal={this.toggleOpenEditCustomer}
                        isCustomerModule
                    />
                )}
            </Grid>
        );
    }
}

PersonalTab.propTypes = {
    data: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    loadingDeals: PropTypes.bool.isRequired,
    getServicesData: PropTypes.func.isRequired,
    loadingInvoices: PropTypes.bool.isRequired,
    getROsTableColumns: PropTypes.func.isRequired,
    getDealsTableColumns: PropTypes.func.isRequired,
    loadingOpportunities: PropTypes.bool.isRequired,
    unsubscribeEditCustomer: PropTypes.func.isRequired,
    getOpportunitiesTableColumns: PropTypes.func.isRequired,
    classes: PropTypes.oneOfType([PropTypes.object]).isRequired,
    opportunities: PropTypes.arrayOf(
        PropTypes.shape({
            make: PropTypes.string,
            trim: PropTypes.string,
            year: PropTypes.string,
            model: PropTypes.string,
            status: PropTypes.string,
            leadCode: PropTypes.number,
            modifiedOn: PropTypes.string,
            processStage: PropTypes.string,
        }),
    ).isRequired,
    deals: PropTypes.arrayOf(
        PropTypes.shape({
            make: PropTypes.string,
            year: PropTypes.string,
            model: PropTypes.string,
            status: PropTypes.string,
            dealType: PropTypes.string,
            soldDate: PropTypes.string,
            stockNumber: PropTypes.string,
            accountNumber: PropTypes.string,
        }),
    ).isRequired,
    invoices: PropTypes.arrayOf(
        PropTypes.shape({
            date: PropTypes.string,
            total: PropTypes.string,
            status: PropTypes.string,
            vehicleVin: PropTypes.string,
            vehicleYear: PropTypes.string,
            vehicleMake: PropTypes.string,
            vehicleModel: PropTypes.string,
            invoiceNumber: PropTypes.string,
        }),
    ).isRequired,
};

export default withStyles(styles)(PersonalTabContainer(PersonalTab));
